{
  "vitalsEntry": {
    "title": "Vitals",
    "subtitle": "Record and review vital signs",
    "printLabel": "Print Vitals",
    "recordSection": "Record Vitals",
    "save": "Record Vitals",
    "cancel": "Cancel",
    "saving": "Recording...",
    "recordedSuccess": "Vitals recorded successfully",
    "recordedError": "Failed to record vitals",
    "invalidEncounter": "Invalid encounter ID.",
    "historyTitle": "Recent Vitals",
    "loadingHistory": "Loading vitals...",
    "loadError": "Failed to load vitals.",
    "emptyHistory": "No vitals recorded for this encounter.",
    "morseTitle": "Morse Fall Scale",
    "bradenTitle": "Braden Scale (Pressure Injury Risk)",
    "riskScalesSaved": "Risk scores recorded",
    "riskScalesFailed": "Vitals saved, but the risk scores were not recorded"
  },
  "vitals": {
    "systolic": "Systolic BP",
    "diastolic": "Diastolic BP",
    "heartRate": "Heart Rate",
    "respiratoryRate": "Respiratory Rate",
    "temperature": "Temperature",
    "oxygenSaturation": "Oxygen Saturation (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "Pain Score",
    "weight": "Weight",
    "height": "Height",
    "bmi": "BMI",
    "rangeError": "{{field}} must be between {{min}} and {{max}}",
    "placeholders": {
      "temperature": "e.g., 37.0",
      "heartRate": "e.g., 72",
      "respiratoryRate": "e.g., 16",
      "oxygenSaturation": "e.g., 98",
      "systolic": "e.g., 120",
      "diastolic": "e.g., 80",
      "weight": "e.g., 70.5",
      "height": "e.g., 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "Normal",
    "borderline": "Borderline",
    "abnormal": "Abnormal",
    "critical": "Critical"
  },
  "__review_vitalsRange": "Normal-range labels vary by clinical context — verify with local clinical reviewer",
  "tableHeaders": {
    "dateTime": "Date/Time",
    "temperature": "Temp",
    "heartRate": "HR",
    "respiratoryRate": "RR",
    "bloodPressure": "BP",
    "oxygenSaturation": "SpO2",
    "weight": "Weight",
    "height": "Height",
    "pain": "Pain"
  },
  "io": {
    "title": "Intake & Output",
    "addRecord": "Add Record",
    "addRecordSection": "Add I/O Record",
    "loading": "Loading I/O records...",
    "loadError": "Failed to load I/O records.",
    "empty": "No I/O records documented for this encounter.",
    "totals": {
      "intake": "Total Intake",
      "output": "Total Output",
      "balance": "Net Balance",
      "totalsRow": "Totals",
      "netLabel": "Net"
    },
    "negativeWarning": "Negative balance — review fluid status",
    "columns": {
      "dateTime": "Date/Time",
      "type": "Type",
      "category": "Category",
      "amount": "Amount (ml)",
      "notes": "Notes"
    },
    "fields": {
      "type": "Type",
      "category": "Category",
      "amount": "Amount (ml)",
      "notes": "Notes"
    },
    "type": {
      "intake": "Intake",
      "output": "Output"
    },
    "categoryPlaceholder": "Select category...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "Optional notes...",
    "save": "Save Record",
    "cancel": "Cancel",
    "missingValueShort": "--",
    "toast": {
      "added": "I/O record added",
      "addFailed": "Failed to add I/O record",
      "missingFields": "Please fill in required fields"
    }
  },
  "intake": {
    "oral": "Oral",
    "iv": "IV",
    "bloodProducts": "Blood Products",
    "tpn": "TPN",
    "tubeFeeding": "Tube Feeding",
    "other": "Other"
  },
  "output": {
    "urine": "Urine",
    "drain": "Drain",
    "emesis": "Emesis",
    "stool": "Stool",
    "bloodLoss": "Blood Loss",
    "ngSuction": "NG Suction",
    "other": "Other"
  },
  "wound": {
    "title": "Wound Care Documentation",
    "subtitle": "Encounter #{{id}} - Structured wound assessment",
    "newAssessment": "New Wound Assessment",
    "dimensionsTitle": "Dimensions (cm)",
    "woundBedTitle": "Wound Bed (%)",
    "woundBedTotalWarning": "Total: {{total}}% (should be 100%)",
    "woundBedTotalOk": "Total: 100%",
    "previousTitle": "Previous Assessments",
    "empty": "No wound assessments recorded for this encounter.",
    "invalidEncounter": "Invalid encounter ID.",
    "save": "Save Assessment",
    "savedSuccess": "Wound assessment documented",
    "savedError": "Failed to save wound assessment",
    "fields": {
      "woundType": "Wound Type",
      "location": "Location",
      "stage": "Stage",
      "length": "Length",
      "width": "Width",
      "depth": "Depth",
      "granulation": "Granulation",
      "slough": "Slough",
      "eschar": "Eschar",
      "epithelial": "Epithelial",
      "drainageType": "Drainage Type",
      "drainageAmount": "Drainage Amount",
      "surroundingSkin": "Surrounding Skin",
      "treatment": "Treatment Applied",
      "painScore": "Pain Score (0-10)",
      "notes": "Notes"
    },
    "placeholders": {
      "length": "e.g., 3.5",
      "width": "e.g., 2.0",
      "depth": "e.g., 0.5",
      "treatment": "Describe wound care treatment applied...",
      "notes": "Additional observations..."
    },
    "history": {
      "dimensionsLabel": "Dimensions",
      "drainageLabel": "Drainage",
      "painLabel": "Pain",
      "treatmentLabel": "Treatment"
    },
    "stage": {
      "stage1": "Stage 1",
      "stage2": "Stage 2",
      "stage3": "Stage 3",
      "stage4": "Stage 4",
      "unstageable": "Unstageable",
      "deepTissue": "Deep Tissue Injury",
      "na": "N/A"
    },
    "drainageType": {
      "none": "None",
      "serous": "Serous",
      "sanguineous": "Sanguineous",
      "serosanguineous": "Serosanguineous",
      "purulent": "Purulent"
    },
    "drainageAmount": {
      "none": "None",
      "scant": "Scant",
      "small": "Small",
      "moderate": "Moderate",
      "large": "Large",
      "copious": "Copious"
    },
    "woundType": {
      "pressure": "Pressure injury",
      "surgical": "Surgical",
      "diabetic": "Diabetic ulcer",
      "venous": "Venous ulcer",
      "arterial": "Arterial ulcer",
      "traumatic": "Traumatic",
      "skinTear": "Skin tear",
      "other": "Other"
    },
    "location": {
      "sacrum": "Sacrum",
      "coccyx": "Coccyx",
      "leftHeel": "Left heel",
      "rightHeel": "Right heel",
      "leftTrochanter": "Left trochanter",
      "rightTrochanter": "Right trochanter",
      "abdomen": "Abdomen",
      "leftLeg": "Left leg",
      "rightLeg": "Right leg",
      "back": "Back",
      "other": "Other"
    },
    "surroundingSkin": {
      "intact": "Intact",
      "erythema": "Erythema",
      "macerated": "Macerated",
      "indurated": "Indurated",
      "edematous": "Edematous",
      "warm": "Warm",
      "discolored": "Discolored"
    }
  },
  "carePlan": {
    "title": "Care Plans",
    "addPlan": "Add Care Plan",
    "newPlan": "New Care Plan",
    "createPlan": "Create Plan",
    "cancel": "Cancel",
    "empty": "No care plans documented for this patient.",
    "emptyGoals": "No goals defined yet.",
    "goals": "Goals",
    "addGoal": "Add Goal",
    "saving": "Saving...",
    "loading": "Loading care plans...",
    "loadError": "Failed to load care plans.",
    "fields": {
      "title": "Title",
      "startDate": "Start Date",
      "targetDate": "Target Date",
      "description": "Description",
      "target": "Target"
    },
    "placeholders": {
      "title": "e.g., Fall Prevention Plan",
      "description": "Goal description",
      "target": "e.g., No falls within 30 days"
    },
    "history": {
      "startLabel": "Start",
      "targetLabel": "Target",
      "goalsLabel": "Goals"
    },
    "status": {
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "goalStatus": {
      "inProgress": "In Progress",
      "achieved": "Achieved",
      "notAchieved": "Not Achieved"
    },
    "toast": {
      "planCreated": "Care plan created",
      "planCreateFailed": "Failed to create care plan",
      "goalAdded": "Goal added",
      "goalAddFailed": "Failed to add goal",
      "planValidation": "Title and start date are required",
      "goalValidation": "Description and target are required"
    }
  }
}
